// types
import { type ModuleType as QuoteTemplate } from "./_definitions"
import { type State } from "../../types"

export const quoteTemplateSelector = (state: State): QuoteTemplate => state.quoteTemplate
